import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { CSSmainLayout, Flex, Text, Hr, Line } from './Uikit';
import { User } from "./User";
import { FooterPayments } from "./FooterPayments";

export function Footer(props) {
  const { handleCat, active } = { ...props };
  return (
    <CSSfooter>
      <CSSmainLayout>
        <div className=""></div>

        <div>
          <Hr />

          <Flex top>
            <Line>
              <br/>
              <h4>© META&nbsp;Nutrition, 2021</h4>
              <br/>
              <Text sm opacity={0.6}>
                10415 Estonia, Tallinn, Maakri 23/1
              </Text>
            </Line>

            <Line>
              <Flex top right mobLeft>
              <CSSfooterPayments>
                <br/>
                <FooterPayments />
              </CSSfooterPayments>
              </Flex>
            </Line>

        </Flex>

        </div>

        <div className=""></div>

      </CSSmainLayout>
    </CSSfooter>
  );
}

const CSSfooter = styled.div`
  padding: 2em 0;
  margin-top: 4em;
  margin-bottom: 3em;
  /* min-height: 20em; */
  /* background-color: var(--main-bg-darker-color) */
`;


const CSSfooterPayments = styled.div`
  @media (max-width: 991px) {
    padding-top: 1.4em;
    width: 100%;
  }
`